// extracted by mini-css-extract-plugin
export default {"popover":"FileUploadPopover_popover__1BLnK","isHidden":"FileUploadPopover_isHidden__VFjZl","loader":"FileUploadPopover_loader__uuwkj"};